import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-24jam-icu`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegisterAndDate(
  registerId: string | number,
  tanggal: string
) {
  const response = await http
    .getData(
      `/register/${registerId}/monitoring-24jam-icu/tanggal/${tanggal}`
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-24jam-icu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/monitoring-24jam-icu", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateHeader(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-24jam-icu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Hourly (create / update by hourly_id)
async function upsertHourly(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/hourly`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteHourly(id: number, hourlyId: number) {
  const response = await http
    .deleteData(`/monitoring-24jam-icu/${id}/hourly/${hourlyId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Balance cairan (create / update by balance_id)
async function upsertBalance(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/balance`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteBalance(id: number, balanceId: number) {
  const response = await http
    .deleteData(`/monitoring-24jam-icu/${id}/balance/${balanceId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Obat
async function addObat(id: number, data: any) {
  const response = await http
    .postData(`/monitoring-24jam-icu/${id}/obat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObat(id: number, obatId: number, data: any) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/obat/${obatId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteObat(id: number, obatId: number) {
  const response = await http
    .deleteData(`/monitoring-24jam-icu/${id}/obat/${obatId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function importObatFromCpo(id: number) {
  const response = await http
    .postData(`/monitoring-24jam-icu/${id}/obat-import-cpo`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Instruksi
async function addInstruksi(id: number, data: any) {
  const response = await http
    .postData(`/monitoring-24jam-icu/${id}/instruksi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateInstruksi(id: number, instruksiId: number, data: any) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/instruksi/${instruksiId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteInstruksi(id: number, instruksiId: number) {
  const response = await http
    .deleteData(`/monitoring-24jam-icu/${id}/instruksi/${instruksiId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Verifikasi DPJP
async function verifyDpjp(id: number) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/verify-dpjp`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function unverifyDpjp(id: number) {
  const response = await http
    .putData(`/monitoring-24jam-icu/${id}/unverify-dpjp`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/monitoring-24jam-icu/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  getByRegisterAndDate,
  find,
  create,
  updateHeader,
  destroy,
  upsertHourly,
  deleteHourly,
  upsertBalance,
  deleteBalance,
  addObat,
  updateObat,
  deleteObat,
  importObatFromCpo,
  addInstruksi,
  updateInstruksi,
  deleteInstruksi,
  verifyDpjp,
  unverifyDpjp,
  printPdf,
};
